import React from 'react';
import * as mobxReact from 'mobx-react';
import Text from '../../../../global/text/text';
import { ReportConfigurationViewModel } from '../../_reports/report-configuration/report-configuration.viewmodel';
import './report-grouped-fields.scss';
import ReportFieldItem from '../report-field-item/report-field-item';

interface IProps {
    vm: ReportConfigurationViewModel;
}

const ReportGroupedFields = mobxReact.observer((props: IProps) => {
    const { vm } = props;
    const itemsCount = vm.getItems().length;
    const groupedFilteredItems = vm.getGroupedFilteredItems();
    const noItemsFound = !!(itemsCount && groupedFilteredItems.every(el => !el.items.length));
    const headerColumnsStyle = { gridTemplateColumns: '1fr '.repeat(groupedFilteredItems.length) };
    const columnsStyle = { gridTemplateColumns: 'minmax(110px, 1fr) '.repeat(groupedFilteredItems.length) };

    return (
        <div className='report-grouped-fields'>
            <div className='report-grouped-fields__group-headers' style={headerColumnsStyle}>
                {groupedFilteredItems.map(({ groupName }) =>
                    <div key={`${groupName}-header`} className='report-grouped-fields__group-header'>
                        <Text className='report-grouped-fields__group-header-label' message={groupName} />
                    </div>
                )}
            </div>
            {noItemsFound && <Text
                className='report-grouped-fields__no-items-found'
                id='oe.reports.noFieldsFound'
                message='No Fields found.'
                description='Empty list message'
            />}
            <div className='report-grouped-fields__group-columns' style={columnsStyle}>
                {groupedFilteredItems.map(group =>
                    <div key={`${group.groupName}-column`} className='report-grouped-fields__group-column'>
                        {group.items.map(field =>
                            <ReportFieldItem key={field.fieldId} toggle={vm.toggleField} field={field} />
                        )}
                    </div>
                )}
            </div>
        </div>
    );
});

export default ReportGroupedFields;
